import { pairingManuallySlice } from "./reducer";

export const {
  fetchPairingCodeFailure,
  fetchPairingCodeRequest,
  fetchPairingCodeSuccess,
  resetPairingCode
} = pairingManuallySlice.actions;
